import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const PositionList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="position"
                hasCode={true}
                hasDescription={true}
                hasKZName={true}
            />
        </DashboardLayout>
    )
};

export default PositionList;
